function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { DEFAULT_FONT } from "../../builderUiTheme";
import { GOOGLE_FONTS_CATALOG } from "./googleFontsCatalog";
export var BLOCK_TEXT_WRAP_STYLE = {
  minWidth: 0,
  overflowWrap: "break-word",
  wordBreak: "normal",
  whiteSpace: "normal"
};
export var BLOCK_TEXT_WRAP_CSS = "min-width: 0; overflow-wrap: break-word; word-break: normal; white-space: normal;";
export var TABLE_CELL_MIN_WIDTH = 100;
export var TABLE_CELL_WRAP_STYLE = {
  minWidth: TABLE_CELL_MIN_WIDTH,
  maxWidth: "100%",
  overflowWrap: "anywhere",
  wordBreak: "break-word",
  whiteSpace: "normal"
};
export var TABLE_CELL_WRAP_CSS = "min-width: ".concat(TABLE_CELL_MIN_WIDTH, "px; max-width: 100%; overflow-wrap: anywhere; word-break: break-word; white-space: normal;");
export var IMAGE_PLACEHOLDER_SRC = "/imgs/New_Templates_Img/image-placeholder.png";
export var contentBlocks = [{
  type: "heading",
  label: "Heading",
  icon: "heading",
  content: {
    text: "Heading",
    tag: "h1"
  }
}, {
  type: "text",
  label: "Text",
  icon: "text",
  content: {
    text: "Text paragraph goes here..."
  }
}, {
  type: "image",
  label: "Image",
  icon: "image",
  content: {
    src: IMAGE_PLACEHOLDER_SRC,
    url: "",
    alt: "Image Description"
  },
  style: {
    padding: "0",
    margin: "0",
    borderRadius: "0"
  }
}, {
  type: "button",
  label: "Button",
  icon: "button",
  content: {
    text: "Click Me",
    url: "#",
    target: "_blank"
  }
}, {
  type: "divider",
  label: "Divider",
  icon: "divider"
}, {
  type: "page-break",
  label: "Page Break",
  icon: "page-break",
  style: {
    height: "1px"
  }
}, {
  type: "gallery",
  label: "Gallery",
  icon: "gallery",
  content: {
    images: [{
      src: IMAGE_PLACEHOLDER_SRC,
      alt: "Gallery image 1"
    }, {
      src: IMAGE_PLACEHOLDER_SRC,
      alt: "Gallery image 2"
    }, {
      src: IMAGE_PLACEHOLDER_SRC,
      alt: "Gallery image 3"
    }],
    columns: 3
  }
}, {
  type: "list",
  label: "List",
  icon: "list",
  content: {
    items: ["List item one", "List item two", "List item three"],
    listStyle: "check"
  }
}, {
  type: "timeline",
  label: "Process / Steps",
  icon: "timeline",
  content: {
    timelineStyle: "numbered-circle",
    accentColor: "#c8a896",
    showDate: false,
    items: [{
      title: "INQUIRY & HOLD",
      date: "",
      description: "Submit an inquiry to check availability and lock in your preferred date."
    }, {
      title: "COFFEE CONSULTATION",
      date: "",
      description: "A relaxed video call or meet-up with no strict agenda, just conversation."
    }, {
      title: "ENGAGEMENT SESSION",
      date: "",
      description: "An optional session to get comfortable before the main day."
    }, {
      title: "TIMELINE PLANNING",
      date: "",
      description: "About six weeks out we map out the flow of the day and timing."
    }, {
      title: "THE WEDDING DAY",
      date: "",
      description: "I arrive before the scheduled start time, fully focused on you."
    }, {
      title: "GALLERY DELIVERY",
      date: "",
      description: "A private online gallery delivered within the agreed turnaround."
    }]
  },
  style: {
    padding: "20px",
    borderRadius: "12px",
    background: "#ffffff"
  }
}, {
  type: "icon",
  label: "Icon",
  icon: "icon-block",
  content: {
    iconName: "star",
    symbol: "",
    size: "40px"
  },
  style: {
    textAlign: "center",
    padding: "12px",
    color: "#101828"
  }
}, {
  type: "social",
  label: "Social",
  icon: "social",
  content: {
    facebook: "#",
    twitter: "#",
    linkedin: "#",
    instagram: "#"
  }
}, {
  type: "spacer",
  label: "Spacer",
  icon: "spacer",
  style: {
    height: "40px"
  }
}, {
  type: "html",
  label: "HTML",
  icon: "code",
  content: {
    code: "<div style='padding: 16px; background: #f1f5f9; border-radius: 8px; text-align: center;'>Custom HTML</div>"
  }
}, {
  type: "one-column",
  label: "1 Column",
  icon: "one-column",
  content: {
    columns: [[]]
  }
}, {
  type: "two-column",
  label: "2 Columns",
  icon: "column",
  content: {
    columns: [[], []]
  }
}, {
  type: "group",
  label: "Group",
  icon: "column",
  content: {
    columns: [[]]
  },
  style: {
    padding: "12px",
    borderRadius: "8px",
    borderStyle: "none",
    borderWidth: "0px"
  }
}, {
  type: "table",
  label: "Table",
  icon: "table",
  content: {
    headers: ["Column 1", "Column 2", "Column 3"],
    rows: [["Row 1, Cell 1", "Row 1, Cell 2", "Row 1, Cell 3"], ["Row 2, Cell 1", "Row 2, Cell 2", "Row 2, Cell 3"]]
  }
}];
export var extendedBlocks = [{
  type: "quote",
  label: "Quote",
  icon: "quote",
  content: {
    text: "Design is not just what it looks like — design is how it works.",
    author: "Steve Jobs",
    role: "Apple Co-founder"
  },
  style: {
    padding: "24px",
    borderRadius: "8px",
    background: "#f8fafc",
    borderLeft: "4px solid #101828"
  }
}, {
  type: "text-banner",
  label: "Text Banner",
  icon: "notification",
  content: {
    title: "Important update",
    text: "A notification message for your readers.",
    link: "#",
    linkText: ""
  },
  style: {
    padding: "32px 28px",
    borderRadius: "12px",
    background: "#f1f5f9",
    textAlign: "center"
  }
}, {
  type: "social",
  label: "Social Links",
  icon: "social",
  content: {
    facebook: "#",
    twitter: "#",
    linkedin: "#",
    instagram: "#"
  }
}, {
  type: "html",
  label: "Custom Code",
  icon: "code",
  content: {
    code: "<div style='padding: 16px; background: #f1f5f9; border-radius: 8px; text-align: center;'>Custom HTML</div>"
  }
}];
export var layoutBlocks = [{
  type: "cover",
  label: "Cover Page",
  icon: "cover",
  content: {
    title: "Web Development Proposal",
    subtitle: "Prepared for Acme Corporation",
    date: new Date().toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric"
    }),
    author: "WillowSpace Agency",
    description: "A comprehensive plan to redesign your digital platform, enhancing speed, conversions, and user engagement."
  },
  style: {
    padding: "60px 40px",
    borderRadius: "16px",
    background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #312e81 100%)",
    color: "#ffffff",
    textAlign: "left"
  }
}, {
  type: "signature",
  label: "Signature",
  icon: "signature",
  content: {
    clientName: "John Doe",
    clientTitle: "Client Representative",
    clientDate: new Date().toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric"
    }),
    clientSigned: false,
    clientSignature: "",
    providerName: "Jane Smith",
    providerTitle: "Director, WillowSpace",
    providerDate: new Date().toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric"
    }),
    providerSigned: false,
    providerSignature: ""
  },
  style: {
    padding: "30px",
    borderRadius: "12px",
    background: "#f8fafc",
    border: "1px solid #e2e8f0"
  }
}, {
  type: "timeline",
  label: "Milestones / Process",
  icon: "timeline",
  content: {
    timelineStyle: "numbered-circle",
    accentColor: "#c8a896",
    showDate: false,
    items: [{
      title: "INQUIRY & HOLD",
      date: "",
      description: "Submit an inquiry to check availability and lock in your preferred date."
    }, {
      title: "COFFEE CONSULTATION",
      date: "",
      description: "A relaxed video call or meet-up with no strict agenda, just conversation."
    }, {
      title: "ENGAGEMENT SESSION",
      date: "",
      description: "An optional session to get comfortable before the main day."
    }, {
      title: "TIMELINE PLANNING",
      date: "",
      description: "About six weeks out we map out the flow of the day and timing."
    }, {
      title: "THE WEDDING DAY",
      date: "",
      description: "I arrive before the scheduled start time, fully focused on you."
    }, {
      title: "GALLERY DELIVERY",
      date: "",
      description: "A private online gallery delivered within the agreed turnaround."
    }]
  },
  style: {
    padding: "20px",
    borderRadius: "12px",
    background: "#ffffff"
  }
}, {
  type: "card",
  label: "Card",
  icon: "card",
  content: {
    title: "Card Title",
    text: "This is a card description container."
  }
}, {
  type: "three-column",
  label: "3 Columns",
  icon: "three-column",
  content: {
    columns: [[], [], []]
  }
}, {
  type: "gallery",
  label: "Gallery",
  icon: "gallery",
  content: {
    images: [{
      src: IMAGE_PLACEHOLDER_SRC,
      alt: "Gallery image 1"
    }, {
      src: IMAGE_PLACEHOLDER_SRC,
      alt: "Gallery image 2"
    }, {
      src: IMAGE_PLACEHOLDER_SRC,
      alt: "Gallery image 3"
    }],
    columns: 3
  }
}, {
  type: "cta",
  label: "CTA Banner",
  icon: "cta",
  content: {
    title: "Ready to boost your team efficiency?",
    subtitle: "Get started with our premium designs in less than 5 minutes.",
    buttonText: "Get Started Free",
    buttonUrl: "#",
    buttonTarget: "_blank"
  },
  style: {
    padding: "40px",
    borderRadius: "12px",
    background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)",
    color: "#ffffff",
    textAlign: "center"
  }
}, {
  type: "logos",
  label: "Logo Strip",
  icon: "logos",
  content: {
    title: "Trusted by leading brands",
    logos: [{
      src: "https://placehold.co/120x40/e2e8f0/475569.png?text=Brand+1",
      alt: "Brand 1"
    }, {
      src: "https://placehold.co/120x40/e2e8f0/475569.png?text=Brand+2",
      alt: "Brand 2"
    }, {
      src: "https://placehold.co/120x40/e2e8f0/475569.png?text=Brand+3",
      alt: "Brand 3"
    }, {
      src: "https://placehold.co/120x40/e2e8f0/475569.png?text=Brand+4",
      alt: "Brand 4"
    }]
  },
  style: {
    padding: "24px",
    textAlign: "center"
  }
}, {
  type: "accordion",
  label: "Accordion",
  icon: "accordion",
  content: {
    items: [{
      title: "What is included?",
      body: "Full access to all features and premium support."
    }, {
      title: "How does billing work?",
      body: "Simple monthly billing with no hidden fees."
    }, {
      title: "Can I cancel anytime?",
      body: "Yes, cancel your subscription at any time."
    }],
    openIndex: 0
  },
  style: {
    padding: "16px 20px",
    borderRadius: "8px",
    background: "#ffffff"
  }
}, {
  type: "pricing",
  label: "Pricing",
  icon: "pricing",
  content: {
    plans: [{
      name: "Starter",
      price: "$19",
      period: "/mo",
      features: ["5 Projects", "Email Support", "Basic Reports"],
      highlighted: false,
      buttonText: "Choose Starter"
    }, {
      name: "Pro",
      price: "$49",
      period: "/mo",
      features: ["Unlimited Projects", "Priority Support", "Advanced Analytics"],
      highlighted: true,
      buttonText: "Choose Pro"
    }, {
      name: "Enterprise",
      price: "$99",
      period: "/mo",
      features: ["Everything in Pro", "Dedicated Manager", "Custom Integrations"],
      highlighted: false,
      buttonText: "Contact Sales"
    }]
  },
  style: {
    padding: "10px"
  }
}, {
  type: "testimonials",
  label: "Testimonials",
  icon: "testimonials",
  content: {
    items: [{
      quote: "WillowSpace doubled our close rate on proposals!",
      name: "Sarah Jenkins",
      role: "CEO, BrightMedia"
    }, {
      quote: "Best investment we made this year. Highly recommend!",
      name: "Mike Chen",
      role: "Founder, TechFlow"
    }, {
      quote: "Outstanding support and incredible features.",
      name: "Emma Davis",
      role: "Director, Pixel Co"
    }]
  },
  style: {
    padding: "10px"
  }
}];
export var blocks = [].concat(contentBlocks, extendedBlocks, layoutBlocks);
export var LEFT_SIDEBAR_TABS = [{
  id: "blocks",
  label: "Blocks",
  icon: "blocks"
}, {
  id: "templates",
  label: "Sections",
  icon: "templates"
}, {
  id: "layers",
  label: "Layers",
  icon: "layers"
}, {
  id: "ai",
  label: "AI",
  icon: "ai"
}];
export var COMPLEX_BLOCK_TYPES = ["divider", "page-break", "html", "list", "spacer", "social", "table", "icon", "group", "one-column", "two-column", "three-column", "image", "quote", "gallery", "cta", "logos", "accordion", "pricing", "testimonials", "text-banner", "signature", "timeline", "cover"];
export var SPACING_SIDES = [{
  key: "Top",
  label: "Top"
}, {
  key: "Right",
  label: "Right"
}, {
  key: "Bottom",
  label: "Bottom"
}, {
  key: "Left",
  label: "Left"
}];
export var RADIUS_CORNERS = [{
  key: "borderTopLeftRadius",
  label: "Top Left"
}, {
  key: "borderTopRightRadius",
  label: "Top Right"
}, {
  key: "borderBottomRightRadius",
  label: "Bottom Right"
}, {
  key: "borderBottomLeftRadius",
  label: "Bottom Left"
}];
export var RADIUS_UNITS = ["px", "%", "em", "rem"];
export var SIZE_UNITS = ["auto", "px", "%", "em", "rem", "vh", "vw", "fit-content"];
export var SIZE_KEYWORD_UNITS = ["auto", "fit-content", "none"];
/** Units for max-width control (heading / text blocks). */
export var MAX_WIDTH_UNITS = ["none", "px", "%", "em", "rem", "vw"];
export var SPACING_UNITS = ["px", "%", "em", "rem"];
export var OFFSET_SIDES = [{
  key: "top",
  label: "Top"
}, {
  key: "right",
  label: "Right"
}, {
  key: "bottom",
  label: "Bottom"
}, {
  key: "left",
  label: "Left"
}];
export var CLIP_PATH_PRESETS = [{
  value: "",
  label: "None"
}, {
  value: "polygon(0 0, 100% 0, 100% 85%, 0 100%)",
  label: "Diagonal Bottom Right"
}, {
  value: "polygon(0 0, 100% 0, 100% 100%, 0 85%)",
  label: "Diagonal Bottom Left"
}, {
  value: "polygon(0 0, 100% 15%, 100% 100%, 0 100%)",
  label: "Diagonal Top Right"
}, {
  value: "polygon(0 15%, 100% 0, 100% 100%, 0 100%)",
  label: "Diagonal Top Left"
}, {
  value: "polygon(0 0, 100% 0, 85% 100%, 0 100%)",
  label: "Slant Right Edge"
}, {
  value: "polygon(15% 0, 100% 0, 100% 100%, 0 100%)",
  label: "Slant Left Edge"
}, {
  value: "polygon(0 0, 100% 0, 100% 100%, 0 70%)",
  label: "Steep Diagonal Left"
}, {
  value: "polygon(0 0, 100% 0, 100% 70%, 0 100%)",
  label: "Steep Diagonal Right"
}];
export var SPACING_SLIDER_MAX = 500;
export var SPACING_INPUT_MAX = 2000;
export var RADIUS_SLIDER_MAX = 500;
export var RADIUS_INPUT_MAX = 2000;
export var RADIUS_SLIDER_MAX_BY_UNIT = {
  px: 500,
  "%": 100,
  em: 10,
  rem: 10
};
export var RADIUS_INPUT_MAX_BY_UNIT = {
  px: 2000,
  "%": 100,
  em: 50,
  rem: 50
};
export var SIZE_INPUT_MAX_BY_UNIT = {
  px: 2000,
  "%": 100,
  em: 50,
  rem: 50,
  vh: 100,
  vw: 100
};

/** Default layout gap (px) when a block has no explicit style.gap */
export var BLOCK_GAP_DEFAULTS = {
  gallery: 12,
  "one-column": 0,
  "two-column": 24,
  "three-column": 24,
  logos: 24,
  pricing: 16,
  testimonials: 16,
  signature: 20,
  timeline: 16,
  "text-banner": 8,
  social: 14,
  list: 6,
  card: 8,
  quote: 12,
  cta: 12,
  cover: 12,
  accordion: 0
};
export var SINGLE_WEIGHT_FONT_NAMES = ["Great Vibes", "Pacifico", "Dancing Script", "Lobster", "Abril Fatface"];
export var ELEMENT_PART_LABELS = {
  heading: {
    text: "Heading Text"
  },
  text: {
    text: "Text"
  },
  button: {
    text: "Button Text"
  },
  card: {
    title: "Title",
    text: "Body"
  },
  cta: {
    title: "Title",
    subtitle: "Subtitle",
    buttonText: "Button"
  },
  quote: {
    text: "Quote",
    author: "Author",
    role: "Role"
  },
  logos: {
    title: "Title"
  },
  "text-banner": {
    title: "Title",
    text: "Message",
    linkText: "Link"
  },
  cover: {
    title: "Title",
    subtitle: "Subtitle",
    description: "Description",
    author: "Author",
    date: "Date"
  },
  "two-column": {
    leftText: "Left Column",
    rightText: "Right Column"
  },
  "one-column": {
    col1: "Column Content"
  },
  "three-column": {
    col1: "Column 1",
    col2: "Column 2",
    col3: "Column 3"
  }
};
export function resolveElementPartLabel(blockType, partKey) {
  var _ELEMENT_PART_LABELS$;
  var staticLabel = (_ELEMENT_PART_LABELS$ = ELEMENT_PART_LABELS[blockType]) === null || _ELEMENT_PART_LABELS$ === void 0 ? void 0 : _ELEMENT_PART_LABELS$[partKey];
  if (staticLabel) return staticLabel;
  var indexed = partKey.match(/^item_(\d+)_(title|body|quote|name|role|date|description|number)$/);
  if (indexed) {
    var labels = {
      title: "Title",
      body: "Body",
      quote: "Quote",
      name: "Name",
      role: "Role",
      date: "Date",
      description: "Description",
      number: "Number"
    };
    return "Item ".concat(Number(indexed[1]) + 1, " \u2014 ").concat(labels[indexed[2]] || indexed[2]);
  }
  var planField = partKey.match(/^plan_(\d+)_(name|price|period|buttonText)$/);
  if (planField) {
    var _labels = {
      name: "Plan Name",
      price: "Price",
      period: "Period",
      buttonText: "Button"
    };
    return "Plan ".concat(Number(planField[1]) + 1, " \u2014 ").concat(_labels[planField[2]] || planField[2]);
  }
  var planFeature = partKey.match(/^plan_(\d+)_feature_(\d+)$/);
  if (planFeature) {
    return "Plan ".concat(Number(planFeature[1]) + 1, " \u2014 Feature ").concat(Number(planFeature[2]) + 1);
  }
  var listItem = partKey.match(/^item_(\d+)$/);
  if (listItem) return "Item ".concat(Number(listItem[1]) + 1);
  return partKey;
}
export var PDF_SKIP_STYLE_PROPS = new Set(["cursor", "transition", "boxShadow", "backgroundImage", "backgroundSize", "backgroundPosition", "backgroundRepeat", "backgroundOverlayOpacity", "backgroundOverlayColor", "height", "minHeight", "maxHeight", "width", "minWidth", "display", "flex", "flexDirection", "flexWrap", "gap", "gridTemplateColumns", "alignItems", "justifyContent", "columnBackgrounds", "columnWidths", "columnHeights", "columnPaddings", "columnBorderStyles", "columnBorderWidths", "columnBorderColors", "columnBorderRadii", "columnAlignItems", "columnJustifyContents", "imageShape", "innerBorderStyle", "innerBorderWidth", "innerBorderColor", "innerBorderInset"]);

/** Popular fonts shown first when the picker search is empty */
export var POPULAR_GOOGLE_FONT_NAMES = ["DM Sans", "Inter", "Roboto", "Poppins", "Montserrat", "Open Sans", "Lato", "Outfit", "Nunito", "Playfair Display", "Merriweather", "Lora", "Oswald", "Dancing Script", "Pacifico", "Great Vibes", "Fira Code", "JetBrains Mono"];

/** Full Google Fonts catalog (~1290) for the Font Family picker */
export var GOOGLE_FONTS = function () {
  var dmSans = GOOGLE_FONTS_CATALOG.find(function (f) {
    return f.name === "DM Sans";
  });
  var rest = GOOGLE_FONTS_CATALOG.filter(function (f) {
    return f.name !== "DM Sans";
  });
  return [dmSans || {
    name: "DM Sans",
    category: "sans-serif",
    value: DEFAULT_FONT
  }].concat(_toConsumableArray(rest));
}();